import jQuery from "jquery";
const $ = jQuery; // ドルマークに参照を代入(慣習的な $ を使うため)

import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

/*
 * rentalspace
*/

/*
// Home - Hero
const homeSwiper = new Swiper('#home-hero-swiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
  },
});
*/

// Home - Swiper
const rentalspaceSwiper = new Swiper('.rentalspace-content-swiper', {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    991: {
      spaceBetween: 18,
      slidesPerView: 2,
    }
  }
});
